export default __webpack_public_path__ + "cac9f28f6250e9f3b46ac38624382d23.png";